import {type BskyAgent} from '@atproto/api'

import {wsocFetch, xrpcPath} from '#/lib/wsoc/fetch'

export interface GetReauthTokenResponse {
  reauthJwt: string
}

export async function getReauthToken(
  agent: BskyAgent,
  options?: {signal?: AbortSignal},
): Promise<GetReauthTokenResponse> {
  const accessJwt = agent.session?.accessJwt
  if (!accessJwt) {
    throw new Error('getReauthToken requires an authenticated session')
  }
  return wsocFetch<GetReauthTokenResponse>(
    xrpcPath('eu.wsocial.server.getReauthToken'),
    {method: 'GET', accessJwt, signal: options?.signal},
  )
}
